import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from '@mui/material';
import { useMemo } from 'react';
import { useGoogleSheetSelectors } from '../../../Google/Sheets/UseGoogleSheetSelector';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const useGoogleSheetSelectorsWidget = () => {
    const { components } = useGoogleSheetSelectors({});
    const component = useMemo(() => (_jsxs(Stack, { gap: 1, children: [_jsx(Typography, { variant: "h5", children: "SpreadsheetSelector" }), components.SpreadsheetSelector, _jsx(Typography, { variant: "h5", children: "SpeadsheetUrlLink" }), components.SpeadsheetUrlLink, _jsx(Typography, { variant: "h5", children: "SheetSelector" }), components.SheetSelector, _jsx(Typography, { variant: "h5", children: "RangeSelector" }), components.RangeSelector] })), [components]);
    return {
        name: 'useGoogleSheetSelectors',
        category: 'composite',
        component,
    };
};
